export default __webpack_public_path__ + "static/media/veggiebites-wide@2x.c763f7f6.jpg";